module.exports = __webpack_public_path__ + "static/media/AlQadirLogo.77bd6d7a.png";